import { createAsyncThunk } from '@reduxjs/toolkit';
import { getResultImages } from '../../services/result_images';

export const getResult = createAsyncThunk(
    'about',
    async (data, { getState, rejectWithValue }) => {
      try {
        const token = getState().auth.token;
        const response = await getResultImages(data, token.token);
        
        return { data: response.data.list, total: response.data.total };
      } catch (err) {
        console.log(err.response.data);
        return rejectWithValue(err.response?.data?.error || 'Failed to fetch users');
      }
    }
  );
  